import { AlkLogger } from '@alk/core';
import { EConnectionState } from '../../enums';
import { IDataTransferService } from './data-transfer.interface';
import { injectable } from 'inversify';
import { NEVER, Observable } from 'rxjs';

@injectable()
export class DataTransferServiceMock implements IDataTransferService {
    connectionStateObserver(): Observable<EConnectionState> {
        return NEVER;
    }

    send(message: Uint8Array): void {
        AlkLogger.info('[DataTransferServiceMock#send]', message);
    }

    messageObserver(): Observable<Uint8Array> {
        AlkLogger.info('[DataTransferServiceMock#messageObserver]');

        return new Observable<Uint8Array>();
    }

    close(): void {
        AlkLogger.info('[DataTransferServiceMock] close()');
        sessionStorage.setItem('SFX_IS_LOGGED', 'false');
        location.href = '/';
        location.reload();
    }

    open(): Promise<void> {
        AlkLogger.info('[DataTransferServiceMock#open]');

        return Promise.resolve();
    }
}
